import React from 'react';
import { useLanguage } from '../../assets/js/LanguageContext';

const PrivacyNoticeEs = () => (
  <>
    <p>
      En cumplimiento de la normativa vigente sobre Protección de Datos de Carácter Personal en todos los países en los que opera The Pulse, le informamos que los datos personales que nos facilite mediante la cumplimentación de formularios, el registro o el uso de la plataforma, pasarán a formar parte de un fichero titularidad de la empresa responsable del desarrollo de The Pulse.
    </p>
    <p>
      Estos datos serán utilizados exclusivamente para gestionar su participación en el uso de la herramienta, el análisis emocional y de rendimiento, la generación de informes personalizados, así como para el desarrollo de mejoras de la plataforma, estudios internos y validaciones de producto.
    </p>
    <p>
      The Pulse garantiza la estricta confidencialidad de los datos, los cuales no serán utilizados para fines distintos a los descritos, ni serán compartidos con terceros salvo que sea necesario para la prestación del servicio o por obligación legal.
      Toda la información se almacena y procesa en servidores seguros, con cifrado de extremo a extremo mediante protocolos SSL, cumpliendo con los más altos estándares en seguridad y protección de datos.
    </p>
    <h4>Ejercicio de Derechos</h4>
    <p>
      En todo momento, usted podrá ejercer sus derechos de acceso, rectificación, cancelación, oposición, limitación y portabilidad de sus datos, escribiendo a nuestro email de contacto: <b>privacidad@thepul.se</b>
    </p>
    <h4>Origen de los Datos</h4>
    <ul>
      <li>Formularios de registro en la plataforma.</li>
      <li>Interacciones dentro de la aplicación.</li>
      <li>Procesos de análisis emocional, transcripción y evaluación de resultados en encuestas o sesiones.</li>
    </ul>
    <h4>Finalidad de la Recogida de Datos</h4>
    <p>
      La finalidad principal es ofrecer un entorno personalizado de análisis emocional y mejora del rendimiento personal o profesional.
      Los datos recopilados son necesarios para prestar correctamente nuestros servicios.
    </p>
    <h4>Destinatarios de los Datos</h4>
    <p>
      Sus datos no se cederán a terceros, salvo para el cumplimiento de obligaciones legales o la prestación de servicios esenciales.
    </p>
    <h4>Cookies</h4>
    <p>
      The Pulse usa el almacenamiento del navegador para lo necesario (mantener tu sesión, recordar el idioma y tu elección de cookies) y, solo si lo aceptas, para estadísticas propias de uso: qué páginas se visitan y algunos clics. No usamos Google Analytics ni cookies de publicidad. Puedes cambiar tu elección en cualquier momento desde «Preferencias de cookies», en el pie de página.
    </p>
    <h4>Consentimiento del Usuario</h4>
    <p>
      Al registrarse y utilizar The Pulse, usted acepta esta Política de Privacidad y autoriza el tratamiento de sus datos conforme a los fines aquí descritos.
    </p>
  </>
);

const PrivacyNoticeEn = () => (
  <>
    <p>
      In compliance with the personal data protection regulations in force in every country where The Pulse operates, we inform you that the personal data you provide by filling in forms, signing up or using the platform will become part of a file owned by the company responsible for developing The Pulse.
    </p>
    <p>
      This data will be used exclusively to manage your use of the tool, emotional and performance analysis, the generation of personalised reports, and the development of platform improvements, internal studies and product validation.
    </p>
    <p>
      The Pulse guarantees the strict confidentiality of your data, which will not be used for purposes other than those described, nor shared with third parties unless necessary to provide the service or required by law.
      All information is stored and processed on secure servers, encrypted with SSL protocols, meeting the highest standards of security and data protection.
    </p>
    <h4>Your Rights</h4>
    <p>
      You may exercise your rights of access, rectification, erasure, objection, restriction and portability at any time by writing to our contact email: <b>privacidad@thepul.se</b>
    </p>
    <h4>Source of the Data</h4>
    <ul>
      <li>Sign-up forms on the platform.</li>
      <li>Interactions within the application.</li>
      <li>Emotional analysis, transcription and result evaluation processes in surveys or sessions.</li>
    </ul>
    <h4>Purpose of Data Collection</h4>
    <p>
      The main purpose is to offer a personalised environment for emotional analysis and the improvement of personal or professional performance.
      The data collected is necessary to provide our services properly.
    </p>
    <h4>Recipients of the Data</h4>
    <p>
      Your data will not be shared with third parties, except to comply with legal obligations or to provide essential services.
    </p>
    <h4>Cookies</h4>
    <p>
      The Pulse uses browser storage for what is necessary (keeping you logged in, remembering your language and your cookie choice) and, only if you accept, for its own usage statistics: which pages are visited and some clicks. We don’t use Google Analytics or advertising cookies. You can change your choice at any time from “Cookie preferences” in the footer.
    </p>
    <h4>User Consent</h4>
    <p>
      By signing up and using The Pulse, you accept this Privacy Policy and authorise the processing of your data for the purposes described here.
    </p>
  </>
);

const PrivacyNoticeZh = () => (
  <>
    <p>
      为遵守 The Pulse 在所有运营国家/地区适用的个人数据保护现行法规，特此告知：您通过填写表单、注册或使用平台所提供的个人数据，将被纳入 The Pulse 开发责任公司所有的文件中。
    </p>
    <p>
      这些数据将仅用于管理您对工具的使用参与、情绪与绩效分析、生成个性化报告，以及平台改进开发、内部研究和产品验证。
    </p>
    <p>
      The Pulse 保证对数据严格保密，不会将其用于所述目的之外的用途，也不会与第三方共享，除非为提供服务所必需或法律要求。所有信息均在安全服务器上存储和处理，通过 SSL 协议进行端到端加密，符合最高的安全与数据保护标准。
    </p>
    <h4>权利行使</h4>
    <p>
      您可随时通过发送邮件至我们的联系邮箱来行使访问、更正、删除、反对、限制和可携带权： <b>privacidad@thepul.se</b>
    </p>
    <h4>数据来源</h4>
    <ul>
      <li>平台注册表单。</li>
      <li>应用内的互动。</li>
      <li>情感分析、转录以及调查或会话结果评估的流程。</li>
    </ul>
    <h4>数据收集目的</h4>
    <p>
      主要目的是提供个性化的情感分析环境，提升个人或职业表现。所收集的数据是正确提供我们服务所必需的。
    </p>
    <h4>数据接收方</h4>
    <p>
      您的数据不会转让给第三方，除非是为了履行法律义务或提供必要服务。
    </p>
    <h4>Cookie</h4>
    <p>
      The Pulse 使用浏览器存储来满足必要功能（保持您的会话、记住语言和您的 Cookie 选择），并且仅在您同意的情况下，用于我们自己的使用统计：访问了哪些页面以及一些点击。我们不使用 Google Analytics 或广告 Cookie。您可以随时在页脚的「Cookie 偏好设置」中更改您的选择。
    </p>
    <h4>用户同意</h4>
    <p>
      注册并使用 The Pulse 即表示您接受本隐私政策，并授权按照本文所述目的处理您的数据。
    </p>
  </>
);

// Texto legal de la ventana de privacidad del registro, en el idioma de la web
const PrivacyNotice = () => {
  const { language } = useLanguage();
  if (language === 'en') return <PrivacyNoticeEn />;
  if (language === 'zh') return <PrivacyNoticeZh />;
  return <PrivacyNoticeEs />;
};

export default PrivacyNotice;
